import {TimelineMax, Power4} from 'gsap/all';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
import $ from 'jquery';

var controller = new ScrollMagic.Controller({
  // addIndicators: true,
});

var imageUnderCurtain_from = {
  autoAlpha: 0,
};

var imageUnderCurtain_to = {
  ease: Power4.easeOut,
  autoAlpha: 1,
};

var curtain_to = {
  ease: Power4.easeOut,
  width: 0,
};

var slideUp_from = {
  y: '100',
};

var slideUp_to = {
  ease: Power4.easeOut,
  y: 0,
};

var fadeIn_from = {
  autoAlpha: 0,
};

var fadeIn_to = {
  ease: Power4.easeOut,
  autoAlpha: 1,
};

var fadeInSlideUp_from = {
  y: '100',
  autoAlpha: 0,
};

var fadeInSlideUp_to = {
  ease: Power4.easeOut,
  y: 0,
  autoAlpha: 1,
};

var verticalLinksSlideIn_from = {
  ease: Power4.easeOut,
  autoAlpha: 0,
  x: '-250',
};

var verticalLinksSlideIn_to = {
  ease: Power4.easeIn,
  autoAlpha: 1,
  x: 0,
};

var leaveFadeIn_from = {
  autoAlpha: 0,
};

var leaveFadeIn_to = {
  ease: Power4.easeOut,
  autoAlpha: 1,
};

window.onload = function() {

  // $('.accordion .collapsible').each(function() {

  //   let animationVariable = new TimelineMax()
  //     .fromTo(this, 2, fadeInSlideUp_from, fadeInSlideUp_to);

  //   new ScrollMagic.Scene({
  //     triggerElement: this,
  //     reverse:false,
  //   })
  //   .setTween(animationVariable)
  //   .addTo(controller);

  // });

  $('.banner--simple').each(function() {

    let container = $(this);
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    // let form = $(this).find('.animation-class--form');    

    let animationVariable = new TimelineMax()
      // .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to)
      .fromTo(container, 2, fadeIn_from, fadeIn_to, '-=1.5')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  // $('.banner--video').each(function() {

  //   let container = $(this);
  //   let title_line_1 = $(this).find('.animation-class--title-line-1');
  //   let title_line_2 = $(this).find('.animation-class--title-line-2');
  //   // let form = $(this).find('.animation-class--form');    

  //   let animationVariable = new TimelineMax()
  //     // .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to)
  //     .fromTo(container, 2, fadeIn_from, fadeIn_to, '-=1.5')
  //     .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
  //     .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2');

  //   new ScrollMagic.Scene({
  //     triggerElement: this,
  //     reverse:false,
  //   })
  //   .setTween(animationVariable)
  //   .addTo(controller);

  // });

  $('.contact-form').each(function() {

    let title = $(this).find('.animation-class--title');
    let form = $(this).find('.animation-class--form');    

    let animationVariable = new TimelineMax()
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to)
      .fromTo(form, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.banner--image-text-with-paragraphs').each(function() {

    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--preview-pod').each(function() {

    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let date = $(this).find('.animation-class--date');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(date, 1, fadeInSlideUp_from, fadeInSlideUp_to, '-=3')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=3')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--preview-pod-with-thumbnail').each(function() {

    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let logo = $(this).find('.animation-class--logo');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    if (logo.length) {
      animationVariable
        .fromTo(logo, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2.25');
    }

    if (cta.length) {
      animationVariable
        .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');
    }

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.video--background-full-height').each(function() {

    let animationVariable = new TimelineMax()
      .fromTo(this, 3, fadeIn_from, fadeIn_to);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.video--background-16by9').each(function() {

    let animationVariable = new TimelineMax()
      .fromTo(this, 3, fadeIn_from, fadeIn_to);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.pods--square .square').each(function() {

    let animationVariable = new TimelineMax()
      .fromTo(this, 2, fadeInSlideUp_from, fadeInSlideUp_to);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.gallery--static-full-width').each(function() {

    let items = $(this).find('.gallery .gallery-item');

    let staggerInterval = 0.5;
    let time_shift = '-=' + (staggerInterval * items.length);

    let animationVariable = new TimelineMax()
      .staggerFromTo(items, 1, fadeInSlideUp_from, fadeIn_to, 0.25)
      .staggerFromTo(items, 1, slideUp_from, slideUp_to, 0.25, time_shift);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.gallery--bricks-full-width').each(function() {

    let items = $(this).find('.bricks .grid-item');

    let staggerInterval = 0.5;
    let time_shift = '-=' + (staggerInterval * items.length);

    let animationVariable = new TimelineMax()
      .staggerFromTo(items, 1, fadeIn_from, fadeIn_to, 0.25)
      .staggerFromTo(items, 1, slideUp_from, slideUp_to, 0.25, time_shift);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--three-column').each(function() {

    let columns = $(this).find('.column');

    let animationVariable = new TimelineMax()
      .staggerFromTo(columns, 1.5, fadeInSlideUp_from, fadeInSlideUp_to, 0.25);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--project-numbers').each(function() {

    let numbers = $(this).find('.numbers .number');
    let title = $(this).find('.animation-class--title');

    let animationVariable = new TimelineMax()
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to)
      .staggerFromTo(numbers, 0.5, fadeInSlideUp_from, fadeInSlideUp_to, 0.5);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.animation-class--leaf').each(function() {

    let animationVariable = new TimelineMax()
      .fromTo(this, 5, leaveFadeIn_from, leaveFadeIn_to);

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--horizontal-links-mixed-content-without-extra-content').each(function() {

    let sliderMain = $(this).find('.animation-class--slider-main');
    let curtain = $(this).find('.animation-class--curtain');
    let sliderControls = $(this).find('.animation-class--slider-controls');
    let links = $(this).find('.animation-class--horizontal-links');

    let animationVariable = new TimelineMax()
      .fromTo(sliderMain, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(sliderControls, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(links, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--horizontal-links-mixed-content-with-extra-content').each(function() {

    let sliderMain = $(this).find('.animation-class--slider-main');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let sliderControls = $(this).find('.animation-class--slider-controls');
    let links = $(this).find('.animation-class--horizontal-links');

    let animationVariable = new TimelineMax()
      .fromTo(sliderMain, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo([ content, sliderControls ], 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(links, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--vertical-links-mixed-content').each(function() {
    
    let vertical_links = $(this).find('.navigation--vertical-links-mixed-content .link');

    let staggerInterval = 0.25;
    let vertical_link_length = vertical_links.length;
    let time_shift = '-=' + (staggerInterval * vertical_link_length);
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let image_1 = $(this).find('.animation-class--image-1');
    let image_2 = $(this).find('.animation-class--image-2');

    let animationVariable = new TimelineMax()
      .staggerFromTo(vertical_links, 0.5, verticalLinksSlideIn_from, verticalLinksSlideIn_to, staggerInterval)
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, time_shift)
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(image_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5')
      .fromTo(image_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--vertical-links-image').each(function() {
    
    let vertical_links = $(this).find('.navigation--vertical-links-image .link');

    let staggerInterval = 0.25;
    let vertical_link_length = vertical_links.length;
    let time_shift = '-=' + (staggerInterval * vertical_link_length);
    let title = $(this).find('.animation-class--title');
    let slides = $(this).find('.animation-class--slides');

    let animationVariable = new TimelineMax()
      .staggerFromTo(vertical_links, 0.5, verticalLinksSlideIn_from, verticalLinksSlideIn_to, staggerInterval)
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, time_shift)
      .fromTo(slides, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--text-image-with-thumbnails').each(function() {
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');
    let thumbnail_1 = $(this).find('.animation-class--thumbnail-1');
    let thumbnail_2 = $(this).find('.animation-class--thumbnail-2');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo([content, thumbnail_1], 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(thumbnail_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--text-cta-image-with-thumbnails').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let thumbnail_1 = $(this).find('.animation-class--thumbnail-1');
    let thumbnail_2 = $(this).find('.animation-class--thumbnail-2');
    let thumbnail_3 = $(this).find('.animation-class--thumbnail-3');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo([content, thumbnail_1], 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(thumbnail_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5')
      .fromTo(thumbnail_3, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.cta--brick-images-with-text ').each(function() {
    
    let tiles = $(this).find('.mosaic .tile');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to)
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5')
      .staggerFromTo(tiles, 1, fadeInSlideUp_from, fadeInSlideUp_to, 0.5, '-=2');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.cta--image-text ').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--image-text').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--image-text-landscape').each(function() {
    console.log('landscape');
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--timeline').each(function() {

    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title');
    let timeline_bar = $(this).find('.animation-class--mobile-timeline-bar');
    let timeline_arrow_next = $(this).find('.animation-class--mobile-next-year');
    let timeline_arrow_prev = $(this).find('.animation-class--mobile-prev-year');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(timeline_arrow_next, 0.75, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(timeline_arrow_prev, 0.75, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(timeline_bar, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2.26')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--text-image').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--text').each(function() {
    
    let title_line_1 = $(this).find('.animation-class--title-line-1');
    let title_line_2 = $(this).find('.animation-class--title-line-2');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(title_line_1, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(title_line_2, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.75');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--text-video').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.info--video-text').each(function() {
    
    let image = $(this).find('.animation-class--image');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');

    let animationVariable = new TimelineMax()
      .fromTo(image, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(content, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--image-text').each(function() {
    
    let sliderMain = $(this).find('.animation-class--slider-main');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let sliderThumbnail = $(this).find('.animation-class--slider-thumbnail');
    let sliderControls = $(this).find('.animation-class--slider-controls');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(sliderMain, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo([ content, sliderThumbnail, sliderControls ], 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

  $('.carousel--text-image').each(function() {
    
    let sliderMain = $(this).find('.animation-class--slider-main');
    let curtain = $(this).find('.animation-class--curtain');
    let title = $(this).find('.animation-class--title');
    let content = $(this).find('.animation-class--content');
    let sliderThumbnail = $(this).find('.animation-class--slider-thumbnail');
    let sliderControls = $(this).find('.animation-class--slider-controls');
    let cta = $(this).find('.animation-class--cta');

    let animationVariable = new TimelineMax()
      .fromTo(sliderMain, 2, imageUnderCurtain_from, imageUnderCurtain_to)
      .to(curtain, 2, curtain_to, '-=2')
      .fromTo(title, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=2')
      .fromTo([ content, sliderThumbnail, sliderControls ], 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1')
      .fromTo(cta, 2, fadeInSlideUp_from, fadeInSlideUp_to, '-=1.5');

    new ScrollMagic.Scene({
      triggerElement: this,
      reverse:false,
    })
    .setTween(animationVariable)
    .addTo(controller);

  });

}

/*eslint-enable no-unused-vars*/


// WEBPACK FOOTER //
// ./scripts/animations.js